import { render, staticRenderFns } from "./moneyExchange.vue?vue&type=template&id=240b476c&scoped=true&"
import script from "./moneyExchange.vue?vue&type=script&lang=js&"
export * from "./moneyExchange.vue?vue&type=script&lang=js&"
import style0 from "./moneyExchange.vue?vue&type=style&index=0&id=240b476c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240b476c",
  null
  
)

export default component.exports